import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { PrismicReusableContentDataBodyImageGrid } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import clsx from "clsx";
import { graphql } from "gatsby";
import CTA from "../cta/cta";

export const query = graphql`
  fragment ImageGridModule on PrismicReusableContentDataBody {
    ... on PrismicReusableContentDataBodyImageGrid {
      slice_type
      primary {
        css_class
        title
        columns
        variant
      }
      items {
        title
        subtitle
        image {
          gatsbyImageData
          url
          alt
        }
        description {
          richText
        }
        primary_cta_link {
          url
          target
        }
        primary_cta_text
        secondary_cta_link {
          url
          target
        }
        secondary_cta_text
      }
    }
  }
`;

export type IImageGridProps = {
  slice: PrismicReusableContentDataBodyImageGrid;
};

const ImageGrid = (props: IImageGridProps) => {
  const { slice } = props;
  const { primary, items } = slice;

  return (
    <div className={clsx(["", primary?.css_class])}>
      <header>
        <h2>{primary?.title}</h2>
      </header>
      {items && (
        <div>
          {items.map((item) => (
            <div>
              {item.title ||
                (item.subtitle && (
                  <header>
                    {item.title && <h5>{item.title}</h5>}
                    {item.subtitle && <p>{item.subtitle}</p>}
                  </header>
                ))}
              {item.image && (
                <figure>
                  <GatsbyImage
                    image={item.image?.gatsbyImageData}
                    alt={item.image?.alt || "Xometry Resources"}
                    loading="lazy"
                  />
                </figure>
              )}
              {item.description && (
                <div>
                  <PrismicRichText
                    field={item.description.richText}
                    components={htmlSerializer}
                  />
                </div>
              )}
              <footer>
                {item.primary_cta_text && item.primary_cta_link && (
                  <CTA
                    kind="primary"
                    ctaText={item.primary_cta_text}
                    linkURL={
                      item.primary_cta_link && item.primary_cta_link?.url
                    }
                    target={
                      item.primary_cta_link && item.primary_cta_link?.target
                    }
                  />
                )}
                {item.secondary_cta_text && item.secondary_cta_link && (
                  <CTA
                    kind="outline-blue"
                    ctaText={item.secondary_cta_text}
                    linkURL={
                      item.secondary_cta_link && item.secondary_cta_link?.url
                    }
                    target={
                      item.secondary_cta_link && item.secondary_cta_link?.target
                    }
                  />
                )}
              </footer>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageGrid;
